<script setup lang="ts">
import { computed, defineAsyncComponent, nextTick, ref } from 'vue';
import { navigate } from 'vike/client/router';
import i18n from '@/localization/i18n';

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
const hero_image_desktop = `url(${VITE_ASSET_URL}assets/public/assets/img/homepage/Photo_BtoB_desktop.webp)`

const articles = ref([
    {
        id: 1,
        title: 'Comment faire un devis en tant qu’artisan ? Guide complet 2025',
        description: 'Découvrez comment rédiger un devis clair et conforme aux normes en 2025. TVA, mentions obligatoires et outils pratiques : optimisez votre activité d’artisan !',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/DevisImportant.jpg`,
        category: 'Conseils',
        path: '/blog/conseils/comment-faire-un-devis-artisan-2025/',
        publish_date: '08/03/2025'
    },
    {
        id: 2,
        title: 'Trouver des chantiers en électricité : Guide complet',
        description: 'Trouvez plus de chantiers en électricité grâce au bouche-à-oreille, Google Business Profile, topela et les réseaux sociaux. Développez votre activité dès maintenant !',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/EelctricienSeFaireConnaitre1_900x.jpg`,
        category: 'Conseils',
        path: '/blog/conseils/comment-trouver-chantiers-electricite/',
        publish_date: '10/03/2025'
    },
    {
        id: 3,
        title: 'Trouver des clients en tant qu’artisan | Guide complet 2025',
        description: 'Attirez plus de clients en tant qu’artisan grâce au bouche-à-oreille, aux plateformes spécialisées et à topela pour booster votre activité.',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/Article-Educatif-Partnership.jpg`,
        category: 'Conseils',
        path: '/blog/conseils/comment-trouver-des-clients-artisan/',
        publish_date: '19/03/2025'
    },
    {
        id: 4,
        title: 'Logiciel de devis et de facturation pour électriciens',
        description: 'Un logiciel de devis et de facturation pour électriciens ne se limite pas à un simple outil administratif : c’est un véritable allié qui vous fait gagner du temps, réduit les erreurs et améliore votre relation client.',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/ServiceElectricien_1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-electricien/',
        publish_date: '24/03/2025'
    },
    {
        id: 5,
        title: 'Logiciel de devis pour peintres en bâtiment | Topela',
        description: 'Vous l’avez peut-être déjà remarqué : lorsqu’on est peintre en bâtiment, un devis bien structuré et précis est essentiel pour convaincre les clients et organiser son activité. Un logiciel de devis – factures ne sert pas seulement ...',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/ServicePeintreBatiment_1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-peintre/',
        publish_date: '08/04/2025'
    },
    {
        id: 6,
        title: 'Quel statut choisir pour un artisan du bâtiment ? | Guide 2025',
        description: 'Auto-entrepreneur, EURL, SARL : quel statut choisir en tant qu’artisan du bâtiment ? Découvrez les options et comment Topela peut vous aider au quotidien.',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/thumbnail-16x9-quelStatutEntrepreneur.jpg`,
        category: 'Conseils',
        path: '/blog/conseils/quel-statut-artisan-batiment/',
        publish_date: '10/04/2025'
    },
    {
        id: 7,
        title: 'Logiciel de devis – factures pour menuisiers',
        description: 'Un devis mal calculé ou une mauvaise gestion administrative peuvent coûter cher à un menuisier. Un logiciel de devis – factures vous permet d’automatiser vos tâches administratives',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/ServiceMenuisier_1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-menuisier/',
        publish_date: '12/04/2025'
    }
    ,
    {
        id: 8,
        title: 'Gagner du temps sur l’administratif : 5 conseils pour artisans BTP',
        description: 'Marre de la paperasse ? Voici 5 techniques concrètes pour artisans du BTP qui veulent gagner du temps sur l’administratif sans se prendre la tête.',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/loosingTime16x5.webp`,
        category: 'Conseils',
        path: '/blog/conseils/gagner-temps-administratif-artisan-btp/',
        publish_date: '20/04/2025'
    }
    ,
    {
        id: 9,
        title: 'Logiciel de devis pour charpentiers | Topela',
        description: 'Un logiciel de devis et de facturation vous permet d’automatiser vos calculs, de structurer vos offres et de suivre vos paiements, tout en renforçant votre image professionnelle.',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/ServiceCharpentier_1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-charpentier/',
        publish_date: '22/04/2025'
    }
    ,
    {
        id: 10,
        title: 'Comment trouver des clients en tant que plaquiste ?',
        description: 'Découvrez comment attirer des clients en tant que plaquiste grâce au bouche-à-oreille, aux plateformes spécialisées et aux réseaux sociaux pour booster votre activité.',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/Desktop-Mobile-16x5-CommentTrouverClientPlaquiste.jpg`,
        category: 'Conseils',
        path: '/blog/conseils/comment-trouver-client-plaquiste/',
        publish_date: '30/04/2025'
    },
    {
        id: 11,
        title: 'Logiciel de devis pour serruriers-métalliers | Topela',
        description: 'Topela n’est pas un simple logiciel administratif. C’est votre allié de confiance qui vous libère du fardeau des papiers pour vous laisser vous concentrer sur l’essentiel : sécuriser, réparer, fabriquer et installer avec précision.',
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/serrurierIame1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-serrurier-metallier/',
        publish_date: '02/05/2025'
    },
    {
        id: 12,
        title: 'Logiciel de devis pour paysagistes | Topela',
        description: "Gagnez du temps avec Topela, le logiciel de devis et de facturation conçu pour les paysagistes. Devis automatisés, suivi de chantiers, TVA intégrée. Essai gratuit 14 jours !",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/ServicePaysagiste_1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-paysagiste/',
        publish_date: '20/05/2025'
    },
    {
        id: 13,
        title: 'Comment se faire connaître : Guide Électricien',
        description: "Se faire connaître est toujours compliqué au lancement, et l’on atteint rapidement la limite de son réseau. Alors comment faire pour développer son activité ?",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/thumbnail-16x9-trouverchantierelectricien.webp`,
        category: 'Conseils',
        path: '/blog/conseils/comment-se-faire-connaitre-electricien-guide/',
        publish_date: '24/05/2025'
    },
    {
        id: 14,
        title: 'Logiciel de devis pour couvreurs-zingueurs | Topela',
        description: "Gagnez du temps avec Topela, le logiciel de devis et de facturation conçu pour les couvreurs-zingueurs.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/couvreurZingueur-1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-couvreur-zingueur/',
        publish_date: '09/06/2025'
    },
    {
        id: 15,
        title: 'Logiciel de devis pour plâtriers-plaquistes | Topela',
        description: "Gagnez du temps avec Topela, le logiciel de devis et de facturation conçu pour les plâtriers-plaquistes. Devis automatisés, conformité aux normes du bâtiment, suivi des paiements. Essai gratuit de 14 jours !",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/plaquiste1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-platrier-plaquiste/',
        publish_date: '30/06/2025'
    },
    {
        id: 16,
        title: 'Logiciel de devis pour artisans TCE | Topela',
        description: "Découvrez les avantages d’un logiciel de devis-facturation pour votre activité d’artisan TCE ou rénovateur. Gagnez du temps, structurez vos chantiers, améliorez votre gestion.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/ArtisanTCE_DevisEnLigne_1000x600.webp`,
        category: 'Logiciels',
        path: '/blog/logiciels/logiciel-devis-artisan-tce/',
        publish_date: '17/07/2025'
    },
    {
        id: 17,
        title: 'Optimisez la gestion de votre activité professionnelle : gagnez du temps et de l’argent',
        description: "Organisation, chantiers, finances : découvrez comment mieux gérer votre activité dans le bâtiment pour gagner du temps et améliorer votre rentabilité.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/desktop-mobile-16x5-quelStatutEntrepreneur.jpg`,
        category: 'Conseils',
        path: '/blog/conseils/optimiser-la-gestion-de-votre-activite-professionnelle/',
        publish_date: '26/12/2025'
    },
    {
        id: 18,
        title: 'Topela x Pennylane : une connexion pensée pour faire gagner du temps aux pros et artisans',
        description: "Découvrez comment la connexion entre Topela et Pennylane facilite la transmission des factures, simplifie le pilotage de l’activité et fluidifie la collaboration avec le cabinet comptable.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/thumbnail-16x9-topela-pennylane.webp`,
        category: 'Conseils',
        path: '/blog/conseils/topela-pennylane-gestion-facturation/',
        publish_date: '02/05/2026'
    }
])

const categories = ref([
    'Conseils',
    'Logiciels'
])

const current_category = ref('')

const set_category = async (category: string) => {
    current_category.value = category
    const overflow_container = document.getElementById('overflow-container')
    await nextTick(() => {
        if (overflow_container) {
            overflow_container.scrollTo(0, 0)
        }
    })
}

const filtered_articles = computed(() => {
    if (current_category.value === '') {
        return articles.value
    }

    return articles.value.filter(article => article.category === current_category.value)
})

const front_article = computed(() => {
    return filtered_articles.value[0]
})

const navigate_to_article = async (path: string) => {
    await navigate(path)
}

const t = i18n.global.t
</script>

<template>
    <Default>>
        <div class="app-content content bg-white pt-5" style="min-height: 73vh; margin-left: 0px">
            <div id="overflow-container" class="content-wrapper container bg-white h-100 pt-0 pt-md-5">
                <main id="main">
                    <h2 class="text-center mt-2 mt-lg-5">{{ t('w_txt_blog_heading') }}</h2>
                    <div class="hero-background d-flex justify-content-center align-items-end rounded-3 mb-2 cursor-pointer"
                        :style="{ backgroundImage: `url('${front_article.image}')` }"
                        @click="navigate_to_article(front_article.path)">
                        <div class="p-2 p-lg-5">
                            <h1 class="text-white text-center px-0 px-lg-5 d-none d-lg-block">
                                {{ front_article.title }}
                            </h1>
                            <h3 class="text-white text-center px-0 px-lg-5 d-block d-lg-none">
                                {{ front_article.title }}
                            </h3>
                            <p class="text-white text-center px-0 px-lg-5 d-none d-lg-block">
                                {{ front_article.description }}
                            </p>
                        </div>
                    </div>
                    <p class="text-center px-0 px-lg-5 d-block d-lg-none">
                        {{ front_article.description }}
                    </p>

                    <section>
                        <h4 class="mb-4">{{ t('w_txt_blog_recent_articles') }}</h4>
                        <div class="row">
                            <div v-if="filtered_articles.length > 1"
                                v-for="article in filtered_articles.slice().reverse()"
                                :class="{ 'd-none': article.id === front_article.id }" class="col-lg-4 mb-5">
                                <!-- Using .slice().reverse() to display articles in reverse order  -->
                                <div class="">
                                    <img class="rounded-3 w-100 mb-4 cursor-pointer" :src="article.image"
                                        alt="Card image cap" style="aspect-ratio: 16 / 9;"
                                        @click="navigate_to_article(article.path)" />
                                    <div>
                                        <h4 class="cursor-pointer" @click="navigate_to_article(article.path)">{{
                                            article.title }}</h4>
                                        <p>
                                            {{ article.description }}
                                        </p>
                                        <small class="mt-2">
                                            <strong>{{ t('g_txt_published_on') }} {{ article.publish_date }}</strong>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="d-flex justify-content-center mt-0 pt-3">
                                <button class="btn primary-btn">
                                    Plus d'articles
                                </button>
                            </div> -->

                        <div class="mt-5 pt-3">
                            <h4 class="mb-4">{{ t('w_txt_blog_categories') }}</h4>
                            <div class="row">
                                <div class="col-6 col-lg-2 mb-3">
                                    <button class="btn rounded-3 w-100" :class="{
                                        'primary-btn': current_category === '',
                                        'border-blue': current_category !== '',
                                        'text-blue': current_category !== ''
                                    }" @click="set_category('')">
                                        Tous
                                    </button>
                                </div>
                                <div v-for="category in categories" class="col-6 col-lg-2 mb-3">
                                    <button class="btn rounded-3 w-100" :class="{
                                        'primary-btn': current_category === category,
                                        'border-blue': current_category !== category,
                                        'text-blue': current_category !== category
                                    }" @click="set_category(category)">
                                        {{ category }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    </Default>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.primary-btn {
    background-color: #49AFDA;
    color: white;
    border-radius: 10px;
}

.hero-background {
    /* height: 60vh; */
    background-position: 25% center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    margin-top: 5vh;
    position: relative;
    aspect-ratio: 19/9;
}

.hero-background::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    /* Adjust opacity as needed */
    z-index: 1;
    border-radius: 0.5rem;
}

.hero-background * {
    position: relative;
    z-index: 2;
    /* Ensures your text appears above the overlay */
}
</style>